import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroShowcase() {
  return <section data-section-id="256807" id="digitale-exzellenz" className="relative min-h-screen flex items-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/chrotech_hero_mesh_gradient.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/chrotech_hero_mesh_gradient.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/chrotech_hero_mesh_gradient.png-wvc-sizes" alt="Modern IT and AI solutions background" className="w-full h-full object-cover" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/95 to-transparent"></div>
        {}
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-primary/10 to-transparent pointer-events-none"></div>
      </div>

      {}
      <div className="container relative z-10 px-4 md:px-6 pt-32 pb-24 mx-auto">
        <div className="max-w-3xl">
          {}
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[1px] w-10 bg-primary"></div>
            <span className="text-primary text-xs md:text-sm font-semibold tracking-widest uppercase font-default">PREMIUM IT · WEB · KI · MARKETING · CHROTECH<br /></span>
          </div>

          {}
          <h1 className="text-5xl sm:text-6xl md:text-[80px] font-bold text-foreground leading-[1.1] font-default mb-6 tracking-tighter">Moderne <span className="bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent" data-ast-id="f:/src/pages/Home/sections/HeroShowcase.tsx|sig:o7p1vc" data-ast-start="1724" data-ast-end="1953">IT- &amp; KI-Lösungen</span> für Unternehmen</h1>

          {}
          <p className="text-lg md:text-[20px] text-muted-foreground max-w-2xl font-default mb-10 leading-relaxed">Wir verbinden moderne IT-Dienstleistungen, Webentwicklung, Digitales Marketing und intelligente KI-Technologien zu innovativen Lösungen für Unternehmen.</p>

          {}
          
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce opacity-50">
        <div className="w-5 h-8 border-2 border-foreground rounded-lg flex justify-center p-1">
          <div className="w-1 h-2 bg-foreground rounded-lg"></div>
        </div>
      </div>
    </section>;
}